import React from 'react';
import { motion } from 'framer-motion';
type ProgressBarProps = {
  completed: number;
  total: number;
};
export function ProgressBar({
  completed,
  total
}: ProgressBarProps) {
  const percent = Math.round(completed / total * 100);
  return <div className="sticky top-0 z-20 border-b border-line bg-paper/85 backdrop-blur" data-id="element-69" data-mp="iw1uz6phtvfp">
      <div className="mx-auto flex w-full max-w-readable items-center gap-4 px-6 py-3" data-id="element-70" data-mp="dya2aah0y5ag">
        <p className="text-sm font-semibold text-ink" data-id="element-71" data-mp="1aloic6iro07y">
          {completed} de {total} verificaciones
        </p>
        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-mist" role="progressbar" aria-valuenow={completed} aria-valuemin={0} aria-valuemax={total} aria-label="Progreso del Protocolo CNS" data-id="element-72" data-mp="16lw8lqhmzo10">
          <motion.div className="h-full rounded-full bg-mint" animate={{
          width: `${percent}%`
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} data-id="element-73" data-mp="3mdk0v8lpgsdh" />
        </div>
        <span className="w-10 text-right text-sm tabular-nums text-muted" data-id="element-74" data-mp="3uiakw5rubame">{percent}%</span>
      </div>
    </div>;
}